import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/aboutus";
import Booking from "./pages/booking";
import Checkout from "./pages/checkout";
import Navbar from "./components/navbar";
import ContactUs from "./pages/contactus";
import Success from "./pages/success";
import Failed from "./pages/failed";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/success" element={<Success />} />
        <Route path="/failed" element={<Failed />} />
      </Routes>
    </div>
  );
}

export default App;
